import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

const MTPLMMin = withFilterContext(FilterName.min_mtplm, SearchFiltersDropdown, {
    ...rangeMin,
    ariaLabel: ariaLabel.mtplm.min,
})
const MTPLMMax = withFilterContext(FilterName.max_mtplm, SearchFiltersDropdown, {
    ...rangeMax,
    ariaLabel: ariaLabel.mtplm.max,
})

export const MTPLMMinFacetAndFilter = withFacetContext(FacetName.mtplm, MTPLMMin)
export const MTPLMMaxFacetAndFilter = withFacetContext(FacetName.mtplm, MTPLMMax)
